import './RUMEventDispatcherButton.css';

import React from 'react';
import { useEffect } from 'react';

import { getCssLocator } from '../../common/monitoring/RumConstants';
import RumContext from '../../contexts/RumContext';

export enum TourButtonStages {
    START = 'start',
    EXIT = 'exit',
    FINISH = 'finish'
}

interface Props {
    tourNames: ReadonlyArray<string>
}

// This component contains an invisible button for each element in the cartesian product of tour 
// names and TourButtonStages. Thus, we have a button to click for each action on each tour. 
const RUMEventDispatcherButtons = (props: Props) => {
    return <> {Array.from(buttonsFromTours(props.tourNames))} </>;  
};

function* buttonsFromTours(tourNames: ReadonlyArray<string>): Generator<JSX.Element> {
    for(const tourName of tourNames) {
        for(const stage of Object.values(TourButtonStages)) {
            const id = getInvisButtonId(tourName, stage);
            yield <EventDispatcherButton key={id} id={id} />;
        }
    }
}

interface EventDispatcherButtonProps {
    id: string
}

//Each invisible button corresponds to exactly one action
const EventDispatcherButton = (props: EventDispatcherButtonProps) => {
    const { registerDomEvents } = React.useContext(RumContext);

    useEffect(() => {
        const thisButtonClickEvent = [{ event: 'click', cssLocator: getCssLocator('id', props.id) }];
        registerDomEvents(thisButtonClickEvent);
    }, [props.id, registerDomEvents]);

    return (
        <button id={props.id} className={'invisibleButton'}/>
    );
};

//A repeatable(stateless) way to get the buttonId that corresponds to a tour with given name and action on that tour. 
export const getInvisButtonId = (tourName: string, stage: TourButtonStages) => {
    return `${tourName}-${stage}`;
};

export default RUMEventDispatcherButtons;
